<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useDisciplineStore } from '../model/store'
import { useDisciplineRefresh } from '../model/discipline-refresh.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import DisciplineGeneral from './DisciplineGeneral.vue'
import ModalDisciplineDuplicate from './modals/ModalDisciplineDuplicate.vue'
import ModalDisciplineMerge from './modals/ModalDisciplineMerge.vue'
import ModalDisciplineMergeConfirm from './modals/ModalDisciplineMergeConfirm.vue'
import ModalDisciplineDelete from './modals/ModalDisciplineDelete.vue'
import DisciplineScheduleModals from './DisciplineScheduleModals.vue'

defineOptions({
  name: 'DisciplineOverviewPage',
})

const disciplineStore = useDisciplineStore()
const { refreshDiscipline } = useDisciplineRefresh()

useOnTimezoneChange(() => {
  void refreshDiscipline()
})
</script>

<template>
  <DisciplinePageLoader />
  <DisciplineGeneral
    v-if="disciplineStore.getDiscipline"
  />
  <ModalDisciplineDuplicate />
  <ModalDisciplineMerge />
  <ModalDisciplineMergeConfirm />
  <ModalDisciplineDelete />
  <DisciplineScheduleModals />
</template>
